module.exports = __webpack_public_path__ + "img/PR.219d6b09.png";